import _css from "@emotion/css";
import { jsx as ___EmotionJSX } from "@emotion/core";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme';
var HORIZONTAL_SPACING = "".concat(gridSize() / 2, "px");
export default (function (_ref) {
  var maxWidth = _ref.maxWidth,
      children = _ref.children;
  return jsx("span", {
    css:
    /*#__PURE__*/
    _css({
      display: 'inline-block',
      verticalAlign: 'top',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      padding: "0 ".concat(HORIZONTAL_SPACING),
      maxWidth: typeof maxWidth === 'number' ? "".concat(maxWidth, "px") : maxWidth,
      width: '100%'
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9Mb3plbmdlL0NvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZUkiLCJmaWxlIjoiLi4vc3JjL0xvemVuZ2UvQ29udGVudC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IHR5cGUgTm9kZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuaW1wb3J0IHsgZ3JpZFNpemUgfSBmcm9tICdAYXRsYXNraXQvdGhlbWUnO1xuaW1wb3J0IHsgdHlwZSBUaGVtZVRva2VucyB9IGZyb20gJy4uL3RoZW1lJztcblxuY29uc3QgSE9SSVpPTlRBTF9TUEFDSU5HID0gYCR7Z3JpZFNpemUoKSAvIDJ9cHhgO1xuXG50eXBlIFRoZW1lVG9rZW5zV2l0aENoaWxkcmVuID0gVGhlbWVUb2tlbnMgJiB7XG4gIGNoaWxkcmVuPzogTm9kZSxcbn07XG5cbmV4cG9ydCBkZWZhdWx0ICh7IG1heFdpZHRoLCBjaGlsZHJlbiB9OiBUaGVtZVRva2Vuc1dpdGhDaGlsZHJlbikgPT4gKFxuICA8c3BhblxuICAgIGNzcz17e1xuICAgICAgZGlzcGxheTogJ2lubGluZS1ibG9jaycsXG4gICAgICB2ZXJ0aWNhbEFsaWduOiAndG9wJyxcbiAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgIHRleHRPdmVyZmxvdzogJ2VsbGlwc2lzJyxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgICAgYm94U2l6aW5nOiAnYm9yZGVyLWJveCcsXG4gICAgICBwYWRkaW5nOiBgMCAke0hPUklaT05UQUxfU1BBQ0lOR31gLFxuICAgICAgbWF4V2lkdGg6IHR5cGVvZiBtYXhXaWR0aCA9PT0gJ251bWJlcicgPyBgJHttYXhXaWR0aH1weGAgOiBtYXhXaWR0aCxcbiAgICAgIHdpZHRoOiAnMTAwJScsXG4gICAgfX1cbiAgPlxuICAgIHtjaGlsZHJlbn1cbiAgPC9zcGFuPlxuKTtcbiJdfQ== */")
  }, children);
});